import React from 'react';

// icon-music
// css style can be found in App.css file

export default function IconMusic({ sizelg = false, sizeXL = false }) {

  return (

    <span className={`icon-music ${sizelg ? 'big' : ''} ${sizeXL ? 'xlarge' : ''}`}>
      {/* <svg xmlns="http://www.w3.org/2000/svg" 
            // width="100%" height="100%" 
            fill="currentColor"
            className="bi bi-music-note-beamed" viewBox="0 0 16 16">
            <path d="M6 13c0 1.105-1.12 2-2.5 2S1 14.105 1 13s1.12-2 2.5-2 2.5.896 2.5 2m9-2c0 1.105-1.12 2-2.5 2s-2.5-.895-2.5-2 1.12-2 2.5-2 2.5.895 2.5 2" />
            <path fillRule="evenodd" d="M14 11V2h1v9zM6 3v10H5V3z" />
            <path d="M5 2.905a1 1 0 0 1 .9-.995l8-.8a1 1 0 0 1 1.1.995V3L5 4z" />
        </svg> */}
      <svg xmlns="http://www.w3.org/2000/svg"
        // width="7" height="11" 
        className="bi bi-music-note-beamed" 
        viewBox="0 0 12 12"
        fill="none">
        <path d="M4.54621 2.027C4.16693 1.8361 3.92206 1.46801 3.78632 1.06559C3.73042 0.898029 3.69183 0.726349 3.66655 0.550547C3.6559 0.472261 3.65058 0.435055 3.64525 0.355395C3.64126 0.290842 3.64658 0.213929 3.62529 0.152124C3.58404 0.0353808 3.34449 -0.0332917 3.2327 0.00104454C3.1462 0.0271401 3.1462 0.14251 3.15019 0.216676C3.15818 0.330673 3.15818 0.403588 3.15818 0.518958C3.15685 0.751071 3.15685 0.983183 3.15552 1.2153C3.15419 1.51883 3.15286 1.82236 3.15286 2.12589C3.15152 2.47612 3.15019 2.82498 3.14886 3.17521C3.14753 3.54604 3.1462 3.91687 3.14487 4.28771C3.14354 4.65442 3.14221 4.513 3.14088 4.87971C3.13955 5.21621 3.13822 5.5527 3.13689 5.8892C3.13555 6.17075 3.13555 6.45231 3.13422 6.73387C3.13422 6.93576 3.13289 7.13629 3.13289 7.33819C3.13289 7.43433 3.13289 7.53047 3.13156 7.62661V7.64034C2.6538 7.39587 1.92452 7.43982 1.2365 7.80928C0.280977 8.32158 -0.227391 9.26376 0.0986566 9.91202C0.426035 10.5603 1.25113 10.7031 2.20665 10.1895C3.0038 9.76232 3.52681 9.03302 3.52282 8.43007V3.02001C4.6886 2.98293 5.76922 4.43879 5.76922 4.43879C6.85782 6.41655 5.09317 8.38608 5.09317 8.38608C4.97606 8.75965 5.2156 8.68137 5.2156 8.68137C5.83975 8.29268 6.56504 7.06894 6.56504 7.06894C8.23786 4.19157 4.54621 2.027 4.54621 2.027Z" fill="black" />
      </svg>
    </span>
  );

}

